import { debounce, isElement, forEach } from 'lodash';

const moduleName = 'forms',
    selectors = {
        main: `.js-${moduleName}`
    };

export class Forms {

    constructor(el) {
        if (!isElement(el)) {
            return false;
        }

        this.el = el;
        this.submitElements = el.querySelectorAll('[type="submit"]');
        this.init();
    }

    _preventDoubleSubmission(ev) {
        const submitButton = ev.currentTarget || ev.target;
        const invalidFields = this.el.querySelectorAll('.input-validation-error');

        if (invalidFields.length > 0) {
            return false;
        }

        submitButton.setAttribute('disabled', "disabled");
    }

    bindEvents() {
        forEach(this.submitElements, (element) => {
            element.addEventListener(
                'click',
                debounce(
                    (event) => this._preventDoubleSubmission(event), 200, { 'leading': false, 'trailing': true }
                )
            );
        })
    }

    init() {
        this.bindEvents();
    }
}

function initForm(elements = document.querySelectorAll(selectors.main)) {
    forEach(elements, formElement => {
        new Forms(formElement);

        /* Prevent onsubmit enter */
        formElement.onkeydown = function(e) {
            if(e.key === 'Enter')
            {
                e.preventDefault();
            }
        };
    });
    
}

initForm();